/// <reference types="vite/client" />
// import { TanStackDevtools } from "@tanstack/solid-devtools"
// import { pacerDevtoolsPlugin } from "@tanstack/solid-pacer-devtools"
// import { SolidQueryDevtoolsPanel } from "@tanstack/solid-query-devtools"
import { SolidQueryDevtools } from "@tanstack/solid-query-devtools"
import { createRootRouteWithContext, HeadContent, Outlet, Scripts } from "@tanstack/solid-router"
// import { TanStackRouterDevtoolsPanel } from "@tanstack/solid-router-devtools"
import { TanStackRouterDevtools } from "@tanstack/solid-router-devtools"
import type { JSX } from "solid-js"
import { Hydration, HydrationScript } from "solid-js/web"
import { DefaultCatchBoundary } from "~/components/DefaultCatchBoundary"
import { NotFound } from "~/components/NotFound"
import { ThemeProvider } from "~/components/providers/theme"
import type { RouterContext } from "~/router"
import appCss from "~/styles.css?url"

export const Route = createRootRouteWithContext<RouterContext>()({
  head: () => ({
    meta: [
      {
        charSet: `utf-8`
      },
      {
        name: `viewport`,
        content: `width=device-width, initial-scale=1`
      },
      {
        title: `CKA Tablet`
      }
    ],
    links: [{ rel: "stylesheet", href: appCss }]
  }),
  errorComponent: (props) => {
    return (
      <RootLayout>
        <DefaultCatchBoundary {...props} />
      </RootLayout>
    )
  },
  notFoundComponent: () => <NotFound />,
  shellComponent: RootComponent
})

function RootComponent() {
  return (
    <RootLayout>
      <ThemeProvider>
        <Outlet />
      </ThemeProvider>
      {/*<TanStackDevtools
        plugins={[
          {
            name: "Tanstack Router",
            render: () => <TanStackRouterDevtoolsPanel />
          },
          {
            name: "Tanstack Query",
            render: () => <SolidQueryDevtoolsPanel />
          },
          pacerDevtoolsPlugin()
        ]}
      />*/}
      <SolidQueryDevtools buttonPosition="top-right" />
      <TanStackRouterDevtools position="bottom-right" />
    </RootLayout>
  )
}

function RootLayout({ children }: { children: JSX.Element }) {
  return (
    <html lang="en">
      <head>
        <HydrationScript />
        <HeadContent />
      </head>
      <body>
        <Hydration>{children}</Hydration>
        <Scripts />
      </body>
    </html>
  )
}
